import React from 'react';
import { Page } from 'framework7-react';

import { I18n } from 'Locales';
import { ColumnView } from 'Containers';

import './style.scss';

const BrokenOrUnauthorized = () => (
  <Page id={'unauthorized'}>
    <ColumnView height={'100%'}>
      <img className="unauthorized-image" src={'/static/images/broken-link.png'} />

      <ColumnView paddingHorizontal={20}>
        <div className="screen-title">{I18n.t('general:brokenOrUnauthorized.title')}</div>
        <div className="screen-subtitle pt-24">{I18n.t('general:brokenOrUnauthorized.description')}</div>
      </ColumnView>
    </ColumnView>
  </Page>
);

export default BrokenOrUnauthorized;
